import type { OverviewResponse } from "@ibada/shared-types/overview"

export type { OverviewErrorBody, OverviewResponse } from "@ibada/shared-types/overview"

export {
  OverviewAlertSeverity,
  OverviewChartType,
  OverviewContext,
  OverviewGranularity,
  OverviewModule,
  OverviewSurface,
  OverviewTableColumnType,
  OverviewValueFormat,
  OverviewVisibilityScope,
  type OverviewAlert,
  type OverviewAlertAction,
  type OverviewCard,
  type OverviewChart,
  type OverviewChartSegment,
  type OverviewChartSeries,
  type OverviewDateRange,
  type OverviewMeta,
  type OverviewTable,
  type OverviewTableColumn,
} from "@ibada/shared-types/overview"

/** Alias: finance uses the shared overview contract. */
export type NormalizedFinanceOverviewResponse = OverviewResponse

export enum FinanceOverviewCardId {
  TotalIncome = "totalIncome",
  TotalExpenses = "totalExpenses",
  NetBalance = "netBalance",
  /** Branch scope only: what left for another scope rather than being spent, and what the scope holds today. */
  TransfersOut = "transfersOut",
  CashOnHand = "cashOnHand",
  TransactionCount = "transactionCount",
  ActiveActivitiesCount = "activeActivitiesCount",
}

export enum FinanceOverviewChartId {
  IncomeExpenseTrend = "incomeExpenseTrend",
  IncomeByCategory = "incomeByCategory",
  ExpensesByCategory = "expensesByCategory",
  FinanceByActivity = "financeByActivity",
  FinanceByBranch = "financeByBranch",
  FinanceByGroup = "financeByGroup",
  FinanceByMinistry = "financeByMinistry",
}

export enum FinanceOverviewSeriesKey {
  Income = "income",
  Expense = "expense",
  TransactionCount = "transactionCount",
  Net = "net",
  Balance = "balance",
}

export enum FinanceOverviewTableId {
  ActiveActivities = "activeActivities",
  RecentTransactions = "recentTransactions",
}
